import { render } from "./Unauthorized.vue?vue&type=template&id=144ba394"
const script = {}
script.render = render

export default script